import React from 'react';
import style from './style.module.scss';

export default function WarningBox(props) {
  const { children } = props;
  return (
    <div className={style.warning_box}>
      {children}
    </div>
  )
}